import { gql } from 'graphql-request'

export const VALIDATE_ADMIN_EMAIL = gql`
  query ValidateAdminEmail($email: String!) {
    validateAdminEmail(email: $email)
  }
`
